<template>
<CRow>
    <CCol col="12" sm="7" class="mx-auto">
        <CCard>
            <CCardBody>
                <Form :coupon="coupon" :submit="submit" ref="editForm" />
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
    import { Form } from './partials'
import { mapGetters, mapActions } from 'vuex'
import { StoreUserRelationStatus, CouponMethod } from '@/constants'

export default {
    name: 'EditCoupon',

    components: {
        Form
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (vm.coupon) {
                vm.fetchPublishers({
                    store_id: vm.coupon.store_id,
                    status: StoreUserRelationStatus.ACTIVE,
                    no_paginate: true,
                })
            }
        })
    },

    data() {
        return {
            CouponMethod,
            id: this.$route.params.id,
        }
    },

    computed: {
        ...mapGetters({
            couponById: 'coupon/couponById'
        }),
        coupon() {
            let coupon = this.couponById(this.id)

            if(coupon) {
                return coupon
            }

            this.$router.push('/coupons')
        },
    },

    methods: {
        ...mapActions({
            editCoupon: 'coupon/edit',
            fetchPublishers: 'publisher/fetch',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        submit() {
            const editForm = this.$refs.editForm
            this.setShowLoading()
            this.resetMsg()

            let data = Object.assign({}, this.coupon)
            data.users = data.users.map(user => user.id)

            this.editCoupon(data).then(() => {
                this.setShowLoading(false)
                this.$router.push({name: 'coupons'})
            }).catch(result => {
                if(result.data) {
                    editForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        }
    }
}
</script>